<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<!-- background-image:url(assets/images/background/startup-593327_1920.jpg); -->

<section id="wrapper" class="login-register login-sidebar" style="background-image: linear-gradient(112deg, #154360, transparent);">
  <div class="login-box card" style="opacity: 0.9;position: relative;left: 452px;width: 41%;height: 70%;margin-top: 6%;border-radius: 5px">
      <div >
          <div>
              <form ngNativeValidate [formGroup]="docForm" (ngSubmit)="consultar()" class="form-horizontal form-material"  style="position: absolute; width: 100%; right: 0; top: -93px; height: 136%; padding-top: 1%; background: #ffffffcf; border-radius: 0 7px 7px 0;">
                  <a href="javascript:void(0)" class="text-center db" style="text-decoration: none;width: 100%">
                      <h1 style="font-weight: bold; margin-bottom: 45px;">Consulta de comprobante electrónico</h1>
                  </a>
                  <div class="form-group" style="width: 75%; margin: auto;height: 50px;">
                    <label class="col-sm-12 control-label" style="font-size: large;">Tipo documento</label>
                    <!-- <select formControlName="TipoDocumentoId" style="font-size: large;margin-left: 7px;" class="form-control valid" data-val="true" data-val-number="The field TipoDocumentoId must be a number." data-val-required="Debe seleccionar el tipo de comprobante" id="TipoDocumentoId" name="TipoDocumentoId"><option value="">-- Seleccione tipo de documento-- </option>
                      <option value="01">Factura</option>
                      <option value="07">Nota de Crédito</option>
                      <option value="03">Boleta</option>
                      </select> -->
                      <ng-select id="TipoDocumentoId" [items]="lstipodocs" [bindLabel]="dattipdoc.text" [bindValue]="dattipdoc.value"
                          formControlName="TipoDocumentoId" placeholder="Seleccione tipo de documento"
                          style="font-size: large; margin-left: 17px; width: 493px;">
                      </ng-select>

                  </div>
                  <div class="form-group" style="width: 75%; margin: auto;">
                    <div class="form-group"><label class="col-sm-12 control-label" style="font-size: large;">RUC Emisor</label>
                      <div class="col-sm-12">
                        <input formControlName="RUCEmisor" style="font-size: large;" class="form-control" data-val="true" data-val-required="Debe ingresar el RUC" id="RUCEmisor" name="RUCEmisor" type="text" value="">
                      </div>
                      <div class="col-sm-6">
                        <span class="field-validation-valid" data-valmsg-for="RUCEmisor" data-valmsg-replace="true"></span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" style="width: 75%; margin: 20px auto 0;">
                    <div class="form-group"><label style="font-size: large;" class="col-sm-12 control-label">Numero de serie</label><div class="col-sm-12"><input formControlName="NumeroSerie" style="font-size: large;" class="form-control" data-val="true" data-val-required="Debe ingresar el número de serie" id="NumeroSerie" name="NumeroSerie" type="text" value=""></div><div class="col-sm-4"></div><div class="col-sm-6"><span class="field-validation-valid" data-valmsg-for="NumeroSerie" data-valmsg-replace="true"></span></div></div>
                  </div>
                  <div class="form-group" style="width: 75%; margin: 20px auto 0;">
                    <div class="form-group"><label style="font-size: large;" class="col-sm-12 control-label">Numero de comprobante</label><div class="col-sm-12"><input formControlName="NumeroComprobante" style="font-size: large;" class="form-control valid" data-val="true" data-val-number="The field NumeroComprobante must be a number." data-val-required="Debe ingresar el número del comprobante" id="NumeroComprobante" name="NumeroComprobante" type="text" value="0"></div><div class="col-sm-4"></div><div class="col-sm-6"><span class="field-validation-valid" data-valmsg-for="NumeroComprobante" data-valmsg-replace="true"></span></div></div>                  </div>
                  <div class="form-group" style="width: 75%; margin: 20px auto 0;">
                    <div class="form-group"><label style="font-size: large;" class="col-sm-12 control-label">Monto emitido</label><div class="col-sm-12"><input formControlName="MontoEmitido" style="font-size: large;" class="form-control" data-val="true" data-val-number="The field MontoEmitido must be a number." data-val-required="Debe ingresar el monto emitido" id="MontoEmitido" name="MontoEmitido" type="text" value="0"></div><div class="col-sm-4"></div><div class="col-sm-6"><span class="field-validation-valid" data-valmsg-for="MontoEmitido" data-valmsg-replace="true"></span></div></div>                  </div>
                  <div class="form-group" style="width: 75%; margin: 20px auto 0;">
                    <div class="form-group">
                      <label style="font-size: large;" class="col-sm-12 control-label">Fecha de emisión</label>
                      <div class="col-sm-12">
                        <!-- <input formControlName="fecha" style="font-size: large;" class="form-control" placeholder="yyyy-mm-dd"
                        name="fecha" type="date"> -->
                        <input id="fecha_doc" class="form-control" type="date" formControlName="fecha">
                      </div>

                  </div>
                </div>
                <div class="row">
                  <div class="g-recaptcha" style="margin-left: 200px;margin-top: 19px;" id="recaptcha" name="recaptcha" #recaptcha> </div>
                  <i style="font-size: xx-large;margin-left: 10px;margin-top: 42px;" (click)="reloadcatpcha()" type="button" class="fa fa-refresh" aria-hidden="true"></i>
                  <div *ngIf="captchaError" class="error">Recaptcha no verificado.</div>

                  <!-- <button class="g-recaptcha"
        data-sitekey="6LcIK28aAAAAAJTUA_s6E1HrsdV6ZKS7md8FxV0B"
        data-callback='onSubmit'
        data-action='submit'>Submit</button> -->
                </div>
                  <div class="form-group text-center m-t-20" style="width: 75%; margin: 20px auto 0;">
                    <button [disabled]="loadRegister" style="height: 37px;font-size: large;" type="submit" name="accion" value="visualizar" class="signin-btn bg-primary" id="btnRegistrar"><i class="fa fa-search" aria-hidden="true"></i>
                    <span [hidden]="!loadRegister" style="padding-right: 10px;"><i class="fa fa-spin fa-spinner"></i></span>&nbsp; Consultar</button>
                  </div>
                  <div *ngIf="valcaptcha" class="row" style="margin-top: 10px;width: 75%;margin-left: 146px;font-size: large;">
                      <i style="font-size: xx-large;margin-left: 60px;" (click)="descargarDocumentoCPE('CPE')" type="button" class="fa fa-file-code-o" aria-hidden="true"></i>
                     <br>
                     &nbsp; XML
                     <i style="font-size: xx-large;margin-left: 39px;" (click)="descargarDocumentoCPE('CDR')" type="button" class="fa fa-file-code-o" aria-hidden="true"></i>
                     <br>
                     &nbsp; CDR
                     <i style="font-size: xx-large;margin-left: 48px;" (click)="descargapdfdocumento()" type="button" class="fa fa-file-pdf-o" aria-hidden="true"></i>
                     <br>
                      &nbsp; PDF

                  </div>

              </form>
          </div>
      </div>
  </div>
</section>
<!-- ============================================================== -->
<!-- End Wrapper -->
<!-- ============================================================== -->



<!-- <html>
<head>
<title>reCAPTCHA demo: Simple page</title>
<script src="https://www.google.com/recaptcha/api.js" async defer></script>
</head>
<body>
<form action="?" method="POST">
<div class="g-recaptcha" data-sitekey="6LeDuGMaAAAAABM_mKJ2j0Kwql2q6Qb397hL8LGI"></div>
<br/>
<input type="submit" value="Submit">
</form>
</body>
</html> -->
